import Axios from "@app/api/axios";
import { REPORTS, CREDITS_REPORT } from "@utils/constant";

const getCreditReports = (id = "") =>
  Axios.get(`${REPORTS}/${id}/${CREDITS_REPORT}`);

export default getCreditReports;
